import React from "react";

export default class Restore extends React.Component {

    async componentDidMount() {
        await sessionStorage.clear();
        await localStorage.clear();
        this.props.setNavigate("/")
    }

    render() {
        return <></>
    }
}